import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { getBespokeEnquiries, createBespokeEnquiry, updateBespokeEnquiryStatus } from "../../api/bespokeEnquiry";

const initialState = {
  list: [],
  total: 0,
  loading: false,
  error: null,
};

export const BespokeEnquirySlice = createSlice({
  name: "bespokeEnquiry",
  initialState,
  reducers: {
    list: (state, action) => {
      state.list = action.payload;
    },
    totalCount: (state, action) => {
      state.total = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const FetchBespokeEnquiries = createAsyncThunk(
  "FetchBespokeEnquiries",
  async (obj, { dispatch }) => {
    try {
      const response = await getBespokeEnquiries(obj);
      if (response?.code === 1) {
        dispatch(list(response?.data?.list || []));
        dispatch(totalCount(response?.data?.total || 0));
      }
      return response;
    } catch (error) {
      toast.error(error.message, { autoClose: false, closeButton: true });
      dispatch(setError(error.message));
    }
  }
);

export const CreateBespokeEnquiry = createAsyncThunk(
  "CreateBespokeEnquiry",
  async (obj, { dispatch }) => {
    try {
      const response = await createBespokeEnquiry(obj);
      if (response?.code === 1) {
        toast.success(response?.message || "Bespoke enquiry submitted successfully");
      } else {
        toast.error(response?.message || "Failed to submit bespoke enquiry");
      }
      return response;
    } catch (error) {
      toast.error(error.message, { autoClose: false, closeButton: true });
      return { code: 0, message: error.message };
    }
  }
);

export const UpdateBespokeEnquiryStatus = createAsyncThunk(
  "UpdateBespokeEnquiryStatus",
  async (obj, { dispatch }) => {
    try {
      const response = await updateBespokeEnquiryStatus(obj);
      if (response?.code === 1) {
        toast.success(response?.message || "Status updated successfully");
      } else {
        toast.error(response?.message || "Failed to update status");
      }
      return response;
    } catch (error) {
      toast.error(error.message, { autoClose: false, closeButton: true });
      return { code: 0, message: error.message };
    }
  }
);

export const { list, totalCount, setLoading, setError } = BespokeEnquirySlice.actions;

export default BespokeEnquirySlice.reducer;
